import {
  LateCancelCountsDto,
  LateCancelListResponseDto,
  LateCancelListStatus,
  LateCancelRecordDto,
} from '../core/cancellation-policy';
import { HttpClient } from './http';

export interface ListLateCancelsParams {
  status?: LateCancelListStatus;
  /** 1-based. */
  page?: number;
}

export interface LateCancelsService {
  list: (params?: ListLateCancelsParams) => Promise<LateCancelListResponseDto>;
  counts: () => Promise<LateCancelCountsDto>;
  resolve: (id: string) => Promise<LateCancelRecordDto>;
  unresolve: (id: string) => Promise<LateCancelRecordDto>;
}

// createQueryParams turns an undefined value into `key=`, which the server's IsIn rejects.
function definedOnly(params: ListLateCancelsParams): Record<string, unknown> {
  const query: Record<string, unknown> = {};
  if (params.status !== undefined) query.status = params.status;
  if (params.page !== undefined) query.page = params.page;
  return query;
}

export function createLateCancelsService(
  httpClient: HttpClient,
  baseUrl: string,
): LateCancelsService {
  return {
    list: (params = {}) =>
      httpClient<LateCancelListResponseDto>(`${baseUrl}/late-cancels`, 'get', {
        query: definedOnly(params),
      }),

    counts: () =>
      httpClient<LateCancelCountsDto>(`${baseUrl}/late-cancels/counts`, 'get'),

    resolve: (id) =>
      httpClient<LateCancelRecordDto>(
        `${baseUrl}/late-cancels/${id}/resolve`,
        'post',
      ),

    unresolve: (id) =>
      httpClient<LateCancelRecordDto>(
        `${baseUrl}/late-cancels/${id}/unresolve`,
        'post',
      ),
  };
}
